import locationImg from "icons/location-pin/location.png"

export default {
  img: locationImg,
}
